
import React, { useState, useEffect } from 'react';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { getBookingByFlightNum, selectBookingSearch, selectShowAddPassenger, setShowAddPassenger, } from '_redux/slices/timeline/timeline-data';
import { resetAdditionalPassengers, selectAdditionalPassengers, } from '_redux/slices/prm-bookings/bookings';
import { selectUserDb, selectIata } from '_redux/slices/main-screen/user';
import { postBookingList, resetAdditionalPassengers as resetAdditionalPassengersFormFlags } from "_redux/slices/timeline/timeline-data";
import { selectOutboundFlights, selectInboundFlights, setExpandedFlights, selectExpandedFlights, selectALTPickUpFlights } from '_redux/slices/timeline/flight-information-list';
import { selectDefaultCheckInLocation, selectExpandAllFlights } from '_redux/slices/timeline/timeline-control';
import { selectPickUpLocations } from '_redux/slices/timeline/timeline-areas';
import { resetMenuContext, setFlightContextPoints, setSelectedFlightForContext, showFlightContext } from '_redux/slices/utils/menu-context';


// icons
import { FaCirclePlus, FaCircleArrowDown, FaCircleArrowUp, FaCheckDouble } from "react-icons/fa6";
import { BsPersonFillSlash } from "react-icons/bs";


// styling
import { Spacing, Colors } from "_styles";
import * as TaskColors from "../utils/colors";

// custom components
import AdditionalPassengerForm from './additional-passenger-form';
import ActionsModal from '_components/molecules/Modals/actions-modal';

//time
import moment from 'moment';
import FlightNumber from './flight-number';

// functions
import { formatCarrierCodeAndFlightNumber } from '_utils/functions';


// change colour blue for dep, green for arr
const getBackgroundColor = (flightInfo, flight, type) => {
    if (!flightInfo && !flight && !type) return 'white'
    // check if flight is cancelled
    if (flightInfo?.operatingStatus === "Cancelled") return 'red';
    if (flight?.includes("ALTPickUp")) return TaskColors.ALTPickUps;
    else if (flight?.includes("/boarding")) return "#e895a4";
    else if (type === 'departure') return Colors.PRM_LIGHT_BLUE;
    else if (type === 'arrival') return Colors.LIGHT_GREEN;
    else return 'white'
};

const FlightInformationComponent = ({ flightInfo, flight, type, landedFlight, departureAirport, arrivalAirport, displayFlightNumber, formattedTime, operatingStatus, flightStatus, statusGate, stand, flightToExpand, hasEmptyPRMs }) => {

    const dispatch = useDispatch()
    const handleRightClick = (e) => {
        e.preventDefault();
        dispatch(resetMenuContext());
        dispatch(showFlightContext(true));
        dispatch(setFlightContextPoints({ x: e.pageX, y: e.pageY }));
        dispatch(setSelectedFlightForContext({
            flightNumber: flight,
            flightToExpand: flightToExpand,
            flightInfo: flightInfo
        }));
    };

    return (
        <div onContextMenu={(e) => { handleRightClick(e) }} onDoubleClick={(e) => { handleRightClick(e) }}>
            <div style={{ backgroundColor: getBackgroundColor(flightInfo, flight, type), borderTopColor: landedFlight ? Colors.GRAY_DARK : "none", overflow: 'hidden', flex: 1, padding: Spacing.SCALE_2, margin: 0, opacity: landedFlight ? 0.6 : 1.0 }}>
                {/* flight number / iata / aircraftRegistration */}
                <div style={{ display: 'flex', justifyContent: "space-between", flex: 1, borderBottomWidth: 0.5, borderBottomColor: 'white', borderBottomStyle: 'solid' }}>

                    <div style={{ textAlign: 'left', color: 'white', fontWeight: 'bold', padding: 0, margin: 0, display: 'flex', alignItems: 'center' }}>
                        <FlightNumber
                            flightNumber={displayFlightNumber}
                            codeShares={flightInfo?.CodeShareFlights}
                        />
                        {/* departure/arrival airport with tooltip */}
                        <span
                            data-tippy-content={type === "arrival" ? `Departure Airport: ${departureAirport}` : `Arrival Airport: ${arrivalAirport}`}
                            style={{ marginLeft: '2px', marginRight: '2px' }}
                        >
                            -{type === "arrival" ? departureAirport : arrivalAirport}-
                        </span>
                        {/* aircraft registration with tooltip */}
                        <span
                            data-tippy-content={`Aircraft Registration: ${flightInfo?.aircraftRegistration || 'N/A'}`}
                            style={{ marginLeft: '0px' }}
                        >
                            {flightInfo?.aircraftRegistration ? flightInfo?.aircraftRegistration?.slice(-2) : ""}
                        </span>
                    </div>

                    {/* {hasEmptyPRMs && <BsPersonFillSlash size={18} data-tippy-content="No PRMs" />} */}
                    {/* time stamp badge (on time / delay / early / landed / departed) */}
                    <div style={{ alignItems: 'center', display: 'flex', justifyContent: 'flex-end', padding: 0, margin: 0 }} data-tippy-content="Flight Status">
                        {operatingStatus && !flightStatus && (
                            <p style={{
                                whiteSpace: "nowrap",
                                fontSize: 8,
                                textAlign: 'center',
                                padding: Spacing.SCALE_2,
                                margin: 0,
                                border: '1px solid',
                                borderRadius: 2.5,
                                borderColor: operatingStatus == 'On Time' ? Colors.PRM_LIGHT_BLUE : 'white',
                                color: operatingStatus == 'On Time' ? Colors.PRM_LIGHT_BLUE : 'white',
                                backgroundColor: operatingStatus == 'Early' ? 'green' : operatingStatus == 'Delay' ? 'red' : operatingStatus == 'On Time' ? 'white' : operatingStatus == 'Cancelled' ? 'red' : 'white'
                            }}>{operatingStatus.toUpperCase()}</p>
                        )}
                        {flightStatus && (
                            <p style={{ whiteSpace: "nowrap", fontSize: 8, textAlign: 'center', padding: Spacing.SCALE_2, margin: 0, border: '1px solid', borderRadius: 2.5, color: 'white', backgroundColor: 'green' }}>{flightStatus.toUpperCase()}</p>
                        )}
                    </div>
                </div>

                {/* Time / Gate / Stand */}
                <div style={{ display: 'flex', justifyContent: "space-between", flex: 1 }}>
                    {/* flight time + status badges */}
                    {flight?.includes("ALTPickUp")
                        ? <div style={{ display: 'flex', width: "100%", justifyContent: "space-between", alignItems: "center" }}>
                            {/* time stamp */}
                            <div style={{ display: 'flex' }}>
                                {/* current time stamp */}
                                <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'left' }} data-tippy-content={`Flight Time`}>
                                    <p style={{ textAlign: 'left', color: 'white', padding: 0, margin: 0 }}>{formattedTime ? formattedTime.replace(":", "") : ""}</p>
                                </div>
                            </div>
                            {/* pick up location */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 7 }}>
                                <p style={{ color: 'white', padding: 0, margin: 0 }} data-tippy-content="Pick Up Location">
                                    {flightInfo?.pickUpLocation?.name ?? ""}
                                </p>
                            </div>
                        </div>
                        : <div style={{ display: 'flex', width: "100%", justifyContent: "space-between", alignItems: "center" }}>

                            {/* time stamp */}
                            <div style={{ display: 'flex' }}>
                                {/* current time stamp */}
                                <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'left' }} data-tippy-content={`Flight Time`}>
                                    <p style={{ textAlign: 'left', color: 'white', padding: 0, margin: 0 }}>{formattedTime ? formattedTime.replace(":", "") : ""}</p>
                                </div>
                            </div>
                            {/* gate + stand */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 7 }}>
                                {statusGate != '' && statusGate != 'N/A' ?
                                    <div>
                                        <p style={{ color: 'white', padding: 0, margin: 0 }} data-tippy-content="GATE">
                                            {`G${statusGate}`}
                                        </p>
                                    </div>
                                    : ""}
                            </div>
                            <div>
                                {stand != '' && stand != 'N/A' && stand != '-' ?
                                    <div>
                                        <p style={{ color: 'white', padding: 0, margin: 0 }} data-tippy-content="STAND">
                                            {`S${stand}`}
                                        </p>
                                    </div>
                                    : ""}
                            </div>


                        </div>}

                </div>

            </div>

        </div>
    )
}



const FlightInformation = (props) => {
    //#region redux
    const dispatch = useDispatch()
    const dbUser = useSelector(selectUserDb)
    const iata = useSelector(selectIata);                                       // holds iata of account

    const additionalPassengers = useSelector(selectAdditionalPassengers);       // additional Passengers to be added to flight 
    const outboundFlights = useSelector(selectOutboundFlights);
    const inboundFlights = useSelector(selectInboundFlights);
    const ALTPickUpFlights = useSelector(selectALTPickUpFlights);
    const expandedFlights = useSelector(selectExpandedFlights);                 // list of expanded flights
    const expandAllFlights = useSelector(selectExpandAllFlights);

    const defaultCheckInLocation = useSelector(selectDefaultCheckInLocation);
    const pickUpLocations = useSelector(selectPickUpLocations);
    const bookingSearch = useSelector(selectBookingSearch);
    const showAddPassenger = useSelector(selectShowAddPassenger)

    // local states
    const [arrivalAirport, setArrivalAirport] = useState('');
    const [departureAirport, setDepartureAirport] = useState('');
    const [type, setType] = useState('');
    const [status, setStatus] = useState('');
    const [statusType, setStatusType] = useState('');
    const [statusTime, setStatusTime] = useState('');
    const [flightDate, setFlightDate] = useState('');
    const [statusGate, setStatusGate] = useState('');
    const [stand, setStand] = useState('-');
    const [formattedTime, setFormattedTime] = useState('');
    const [flightNumber, setFlightNumber] = useState("")
    const [displayFlightNumber, setDisplayFlightNumber] = useState("")
    const [flightInfo, setFlightInfo] = useState(null);
    const [landedFlight, setLandedFlight] = useState(false);
    const [highlightedFlight, setHighlightedFlight] = useState(false);
    const [aircraftType, setAircraftType] = useState("");

    const [operatingStatus, setOperatingStatus] = useState("On Time");               // early / delay / on time
    const [flightStatus, setFlightStatus] = useState("");                           // landed / departed badge text

    const [originalTime, setOriginalTime] = useState("");
    const [showTimeDifference, setShowTimeDifference] = useState(false);            // show time difference between status time and original time only if they are different
    const [completedFlight, setCompletedFlight] = useState(false);
    const [trimStandGate, setTrimStandGate] = useState(false)                                  // when both Stand and Gate are 2 digits, make it true to display G: and S:
    //#endregion
    //#region use effect

    // Set flight info
    useEffect(() => {
        if (props?.flight && props?.flight.length > 0) {

            let tempIata = props?.flight?.split("_")?.[1];
            let flightInfo = null;
            let flightNumber = props?.flight?.split("_")?.[0];
            if (flightNumber?.includes("Estimated") || flightNumber?.includes("/boarding") || flightNumber?.includes("ALTPickUp")) {
                flightNumber = flightNumber?.split("/")?.[0];
            }
            setFlightNumber(flightNumber);

            if (flightNumber?.includes('U2')) {
                setDisplayFlightNumber(flightNumber?.replace('U2', 'EZY'))
            }
            else {
                setDisplayFlightNumber(flightNumber)
            }
            //departure flight
            if (iata === tempIata && !props?.flight?.includes("_pickupTime_")) {

                flightInfo = Array.isFullArray(outboundFlights) ? outboundFlights?.find(f => f.flightNumber === flightNumber) : null;
                if (flightInfo) {
                    setFlightInfo(flightInfo);

                    //setType(flightInfo.type);
                    setStatus(flightInfo.operationInfo.status);
                    setStatusType(flightInfo.operationInfo.statusType);
                    setStatusTime(flightInfo.operationInfo.time);
                    setFlightDate(flightInfo?.date ?? "");
                    setStatusGate(flightInfo.gate);
                    setStand(flightInfo.stand);
                    setOperatingStatus(flightInfo.operatingStatus)
                    setOriginalTime(flightInfo?.originalFlightTime)
                    setArrivalAirport(flightInfo?.arrivalAirport ?? "");
                    setDepartureAirport(flightInfo?.departureAirport ?? "");
                    setCompletedFlight(flightInfo.completed ?? false);
                    setAircraftType(flightInfo?.aircraftType ?? "")

                    // set type based on flight info
                    if (flightInfo?.departureAirport === iata) {
                        setType("departure");
                    } else if (flightInfo?.arrivalAirport === iata) {
                        setType("arrival");
                    } else {
                        setType("");
                    }
                }
            } else if (props?.flight?.includes("_pickupTime_") && iata === tempIata) {

                flightInfo = Array.isFullArray(ALTPickUpFlights) ?
                    ALTPickUpFlights?.find(f => f?.flightNumber === flightNumber && new Date(f?.formattedTimeForDisplay)?.toISOString() === props?.flight?.split("_")?.[4]) :
                    null;

                if (flightInfo) {
                    setFlightInfo(flightInfo);
                    //setType(flightInfo.type);
                    setStatus(flightInfo.operationInfo.status);
                    setStatusType(flightInfo.operationInfo.statusType);
                    setStatusTime(flightInfo.operationInfo.time);
                    setFlightDate(flightInfo?.date ?? "");
                    setStatusGate(flightInfo.gate);
                    setStand(flightInfo.stand);
                    setOperatingStatus(flightInfo.operatingStatus)
                    setOriginalTime(flightInfo?.originalFlightTime)
                    setArrivalAirport(flightInfo?.arrivalAirport ?? "");
                    setDepartureAirport(flightInfo?.departureAirport ?? "");
                    setCompletedFlight(flightInfo.completed ?? false);
                    setAircraftType(flightInfo?.aircraftType ?? "")

                    // set type based on flight info
                    if (flightInfo?.departureAirport === iata) {
                        setType("departure");
                    } else if (flightInfo?.arrivalAirport === iata) {
                        setType("arrival");
                    } else {
                        setType("");
                    }
                }
            } else {

                flightInfo = Array.isFullArray(inboundFlights) ? inboundFlights?.find(f => f.flightNumber === flightNumber) : null;
                if (flightInfo) {
                    setFlightInfo(flightInfo);
                    //setType(flightInfo.type);
                    setStatus(flightInfo.operationInfo.status);
                    setStatusType(flightInfo.operationInfo.statusType);
                    setStatusTime(flightInfo.operationInfo.time);
                    setFlightDate(flightInfo?.date ?? "");
                    setStatusGate(flightInfo.gate);
                    setStand(flightInfo.stand);
                    setOperatingStatus(flightInfo.operatingStatus)
                    setOriginalTime(flightInfo?.originalFlightTime)
                    setArrivalAirport(flightInfo?.arrivalAirport ?? "");
                    setDepartureAirport(flightInfo?.departureAirport ?? "");
                    setCompletedFlight(flightInfo.completed ?? false);
                    setAircraftType(flightInfo?.aircraftType ?? "")
                    if (flightInfo.gate !== "N/A" && flightInfo.stand !== "N/A" && flightInfo.stand?.length > 1 && flightInfo.gate?.length > 1) setTrimStandGate(true)

                    // set type based on flight info
                    if (flightInfo?.arrivalAirport === iata) {
                        setType("arrival");
                    } else if (flightInfo?.departureAirport === iata) {
                        setType("departure");
                    } else {
                        setType("");
                    }

                }

            }
        }
    }, [props?.flight, outboundFlights, inboundFlights]);

    // set flight type ( departure or arrival )
    useEffect(() => {
        // check if the oneBooking props is not null and the outboundFlights and inboundFlights are empty array 
        // then there is no outboundFlights or inboundFlights for the airport and use the oneBooking for the information
        if (props?.oneBooking !== null) {
            setStatusGate("");
            setStand("");
            setDepartureAirport(props?.oneBooking?.flightConfirmationDetails?.origin ?? "");
            setArrivalAirport(props?.oneBooking?.flightConfirmationDetails?.destination ?? "");
            if (iata === props?.oneBooking?.flightConfirmationDetails?.origin) {
                setType("departure");
                const time = props?.oneBooking?.flightConfirmationDetails?.departureTime
                    ? moment(new Date(props?.oneBooking?.flightConfirmationDetails?.departureTime)).format("HH:mm")
                    : "";
                setFormattedTime(time);
            } else {
                setType("arrival");
                const time = props?.oneBooking?.flightConfirmationDetails?.arrivalTime
                    ? moment(new Date(props?.oneBooking?.flightConfirmationDetails?.arrivalTime)).format("HH:mm")
                    : "";
                setFormattedTime(time);

            }
        }
    }, [iata, props?.oneBooking])

    // format status time
    useEffect(() => {
        if (statusTime && statusTime.length > 0) {
            const time = moment(new Date(statusTime)).format("HH:mm");
            if (props?.flight?.includes("/boarding")) {
                const boardingTime = moment(new Date(new Date(statusTime).getTime() - 30 * 60 * 1000)).format("HH:mm");
                setFormattedTime(boardingTime);
            } else if (props?.flight?.includes("_pickupTime_")) {
                const pickupTime = moment(new Date(props?.flight?.split("_")?.[4])).format("HH:mm");
                setFormattedTime(pickupTime);
            } else {
                setFormattedTime(time);
            }
        }
        if (statusTime && statusTime.length > 0 && originalTime && originalTime.length > 0) {
            // check if the status time and original time are different
            if (moment(new Date(statusTime)).format("HH:mm") !== moment(new Date(originalTime)).format("HH:mm")) {
                setShowTimeDifference(true);
            } else {
                setShowTimeDifference(false);
            }
        }
    }, [statusTime, originalTime, props?.flight]);

    // set landed flight
    useEffect(() => {
        const currentDate = new Date();
        const statusDate = new Date(statusTime);
        const statusDateWithTime = new Date(`${flightDate}T${statusTime ? statusTime?.split("T")?.[1] : ""}`);
        if (status === "Actual" && statusDateWithTime <= currentDate) {
            if (statusType === "Out of Blocks" || statusType === "Taken Off" || statusType === "Take Off" || statusType === "On Blocks" || statusType === "Touchdown" || statusType === '') {
                setLandedFlight(true);
                // set landed / departed badge text based on flight type
                if (type === "departure") {
                    setFlightStatus("Deprtd");
                }
                if (type === "arrival") {
                    setFlightStatus("Landed");
                }
            } else {
                setLandedFlight(false);
                setFlightStatus("");
            };
        } else {
            setLandedFlight(false);
            setFlightStatus("");
        };
        if (status && status !== "Actual" && statusTime) {

            // add 5 minutes to statusDate
            statusDate.setMinutes(statusDate.getMinutes() + 5);
            // compare the dates
            if (statusDate < currentDate) {
                setLandedFlight(true);
                if (type === "departure") {
                    setFlightStatus("Deprtd");
                }
                if (type === "arrival") {
                    setFlightStatus("Landed");
                }
            } else {
                setLandedFlight(false);
                setFlightStatus("");

            }

        }
    }, [status, statusType, statusTime, type])

    // highlight flight
    useEffect(() => {
        if (bookingSearch && bookingSearch.includes(props.flight)) {
            setHighlightedFlight(true)
        } else {
            setHighlightedFlight(false)
        }
    }, [bookingSearch, props.flight])

    //#endregion

    //#region functions 
    // open selected flight
    const openModal = () => {
        if (props?.flight?.includes("Estimated") || flightNumber?.includes("/boarding") || props?.flight?.includes("ALTPickUp")) return;
        dispatch(getBookingByFlightNum(props?.flight))
        dispatch(setShowAddPassenger(props?.flight))
    }

    // get the passengers position
    const getPaxPositionInfo = (positionInfo) => {
        if (type === "arrival") return null

        if (Object?.keys(positionInfo)?.length > 0) return positionInfo;

        if (defaultCheckInLocation) {
            return {
                locationId: defaultCheckInLocation,
                locationTitle: pickUpLocations?.find((pickUp) => defaultCheckInLocation == pickUp?._id)?.title,
                activity: "Checked-in",
                time: new Date()
            }
        } else return null
    }

    // create document for request
    const createBookingDocument = (passenger, additionalBoard) => {
        // change carrier code if necessary
        const paxPositionInfo = passenger?.locationInfo ? getPaxPositionInfo(passenger?.locationInfo) : null
        const tempFlightNumber = flightInfo?.flightNumber ? flightInfo?.flightNumber : flightNumber;

        // do you have a function that extracts the carrier code and flight number from the full flight number string
        const { carrierCode, number } = formatCarrierCodeAndFlightNumber(tempFlightNumber);


        let paxObj = {
            name: passenger?.firstName.trim() + ' ' + passenger?.secondName.trim(),
            flightDetails: {
                carrierCode: carrierCode?.toUpperCase(),
                flightNumber: number,
                departureDate: flightInfo?.date ? flightInfo?.date : props?.oneBooking?.flightConfirmationDetails?.departureDate,
            },
            assistance: Array.isFullArray(passenger?.assistance) ? passenger?.assistance : ["WCHR"],
            referenceNumber: "",
            dueTime: '',
            bio: "",
            destinationAssistance: true,
            originAssistance: true,
            equipment: false,
            equipmentInformation: {},
            airlineConfirmed: false,
            portal: dbUser.details.type == 'AIRLINE' ? 'airline' : iata,
            errors: [],
            status: "user-confirmed",
            paxPositionInfo,
            originCode: departureAirport,
            destinationCode: arrivalAirport,
            flightType: departureAirport === iata ? "OUTBOUND" : "INBOUND",
            ambiliftRequired: passenger.ambiliftRequired ?? false
        };

        if (!paxObj?.paxPositionInfo) delete paxObj?.paxPositionInfo;
        if (additionalBoard === "onlyBoarding") paxObj["boardingType"] = "onlyBoarding";
        // check if there is a gate, terminal or stand add gateInformation to the paxObj
        if (flightInfo?.gate || flightInfo?.terminal || flightInfo?.stand) {
            paxObj["gateInformation"] = {
                gate: flightInfo?.gate ?? "",
                terminal: flightInfo?.terminal ?? "",
                stand: flightInfo?.stand ?? ""
            }
        };


        console.log('add booking ', paxObj)

        return paxObj
    }

    // add new booking to flight
    const addBooking = (additionalBoard) => {

        let list = [];

        additionalPassengers.forEach(passenger => {
            let doc = createBookingDocument(passenger, additionalBoard);
            list.push(doc)
        });

        /* post booking list */
        dispatch(postBookingList({
            bookings: list,
            iata: iata
        }));

    };

    // close modal
    const closeModal = () => {
        dispatch(setShowAddPassenger(null));
        dispatch(resetAdditionalPassengers())
        dispatch(resetAdditionalPassengersFormFlags())
    }

    // show flights
    const handleExpand = () => {
        // check if expandedFlights is an array with length
        if (Array.isFullArray(expandedFlights)) {
            // if expandedFlights includes the current flight, remove it
            if (expandedFlights?.includes(props?.flightToExpand)) {
                let tempExpandedFlights = expandedFlights.filter(flight => flight != props?.flightToExpand);
                dispatch(setExpandedFlights(tempExpandedFlights));
            } else {
                // if expandedFlights does not include the current flight, add it
                let tempExpandedFlights = [...expandedFlights, props?.flightToExpand];
                dispatch(setExpandedFlights(tempExpandedFlights));
            }
        } else {
            // if expandedFlights is not an array, set it to an array with the current flight
            dispatch(setExpandedFlights([props?.flightToExpand]));
        }
    };

    //#endregion

    return (

        <>
            {iata !== "JER"
                ?
                <FlightInformationComponent
                    flightInfo={flightInfo} flight={props?.flight} type={type} landedFlight={landedFlight}
                    departureAirport={departureAirport}
                    arrivalAirport={arrivalAirport}
                    displayFlightNumber={displayFlightNumber}
                    formattedTime={formattedTime}
                    operatingStatus={operatingStatus}
                    flightStatus={flightStatus}
                    statusGate={statusGate}
                    stand={stand}
                    flightToExpand={props?.flightToExpand}
                    hasEmptyPRMs={props?.hasEmptyPRMs}

                />
                : <div onClick={() => { console.log('clicked', flightInfo) }}>

                    <div style={{ backgroundColor: getBackgroundColor(flightInfo, props?.flight, type), borderTopColor: landedFlight ? Colors.GRAY_DARK : "none", overflow: 'hidden', flex: 1, padding: Spacing.SCALE_4, margin: 0, opacity: landedFlight ? 0.6 : 1.0 }}>

                        {/* flight number + departure / arrival airport */}
                        <div style={{ display: 'flex', justifyContent: "space-between", flex: 1, cursor: 'pointer', padding: 0, margin: 0, borderBottomWidth: 0.5, borderBottomColor: 'white', borderBottomStyle: 'solid' }} onClick={() => openModal()}>

                            {/* flight number + iata */}
                            <p style={{ textAlign: 'left', color: 'white', fontWeight: 'bold', padding: 0, margin: 0 }} data-tippy-content="Flight - Dep - Arival">{displayFlightNumber} - {type === "arrival" ? departureAirport : arrivalAirport} {'(' + aircraftType + ')'}</p>

                            {/* flight complete */}
                            {completedFlight && <FaCheckDouble size={16} style={{ color: "#fff", marginLeft: Spacing.SCALE_12 }} />}
                            {/* {props?.hasEmptyPRMs && <BsPersonFillSlash size={18} data-tippy-content="No PRMs" />} */}
                            {/* add passenger button */}
                            {!props?.flight?.includes("ALTPickUp") && <FaCirclePlus onClick={() => openModal()} style={{ cursor: 'pointer' }} color={type == '' ? Colors.PRM_LIGHT_BLUE : "white"} size={18} data-tippy-content="Add Passenger" />}

                        </div>

                        {/* flight time + status badges */}
                        {props?.flight?.includes("ALTPickUp")
                            ? <div className='mt-1' style={{ display: 'flex', flex: 1, padding: 0, margin: 0, borderBottomWidth: 0.5, borderBottomColor: 'white', borderBottomStyle: 'solid' }}>
                                <div >
                                    <p style={{ textAlign: 'left', color: 'white', fontSize: "11px", fontWeight: "bolder", margin: 0 }}>
                                        {"ALTPickUp Pax"}
                                    </p>
                                </div>
                            </div>
                            : <div className='mt-1' style={{ display: 'flex', flex: 1, padding: 0, margin: 0, borderBottomWidth: 0.5, borderBottomColor: 'white', borderBottomStyle: 'solid' }} onClick={() => openModal()}>

                                {/* time stamp */}
                                <div style={{ display: 'flex', flex: 1.10 }}>

                                    {/* current time stamp */}
                                    <div style={{ flex: 1, display: 'flex', justifyContent: 'left', alignItems: 'left' }}>
                                        <p style={{ textAlign: 'left', color: 'white', padding: 0, margin: 0 }}>{formattedTime}</p>
                                    </div>

                                    {/* original time stamp */}
                                    <div style={{ flex: 1, display: 'flex', justifyContent: 'left', alignItems: 'left' }}>
                                        {showTimeDifference && <p style={{ textDecoration: 'line-through', color: 'white', marginLeft: Spacing.SCALE_8, padding: 0, margin: 0 }}>{moment(new Date(originalTime)).format('HH:mm')}</p>}
                                    </div>

                                </div>

                                {/* time stamp badge (on time / delay / early / landed / departed) */}
                                <div style={{ flex: 1, alignItems: 'center', display: 'flex', justifyContent: 'flex-end', padding: 0, margin: 0 }} data-tippy-content="Flight Status">
                                    {operatingStatus && (
                                        <p style={{
                                            fontSize: 8,
                                            fontWeight: '900',
                                            textAlign: 'center',
                                            padding: Spacing.SCALE_2,
                                            margin: 0,
                                            border: '1px solid',
                                            borderRadius: 2.5,
                                            borderColor: operatingStatus == 'On Time' ? Colors.PRM_LIGHT_BLUE : 'white',
                                            color: operatingStatus == 'On Time' ? 'darkgreen' : 'white',
                                            backgroundColor: operatingStatus == 'Early' ? 'green' : operatingStatus == 'Delay' ? 'red' : operatingStatus == 'On Time' ? 'white' : operatingStatus == 'Cancelled' ? 'red' : 'white'
                                        }}>{operatingStatus.toUpperCase()}</p>
                                    )}
                                    {flightStatus && (
                                        <p style={{ fontSize: 8, textAlign: 'center', padding: Spacing.SCALE_2, margin: 0, border: '1px solid', borderRadius: 2.5, color: 'white', backgroundColor: 'green' }}>{flightStatus.toUpperCase()}</p>
                                    )}
                                </div>
                            </div>}

                        {/* gate info + expand / collapse button */}
                        <div style={{ display: 'flex', flex: 1, justifyContent: 'space-between', padding: 0, margin: 0, flex: 1 }}>

                            {/* gate + stand */}
                            <div style={{ flex: 3, display: 'flex', justifyContent: 'space-between', padding: 0, margin: 0 }}>
                                {statusGate != '' && statusGate != 'N/A' ?
                                    <div style={{ display: 'flex', flex: 1, padding: 0, margin: 0 }}>
                                        <p style={{ color: 'white', padding: 0, margin: 0 }}>{(iata === 'JER' ? 'GATE: ' : 'G: ') + statusGate}</p>
                                    </div>
                                    : ""}

                                {stand != '' && stand != 'N/A' ?
                                    <div style={{ display: 'flex', flex: 1, padding: 0, margin: 0 }}>
                                        <p style={{ color: 'white', padding: 0, margin: 0 }}>{(iata === 'JER' ? 'STAND: ' : 'S: ') + stand}</p>
                                    </div>
                                    : ""}
                            </div>


                            {/* expand / collapse button */}
                            <div style={{ padding: 0, margin: 0, flex: 0.5, display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                {!expandAllFlights && !props?.hasEmptyPRMs && (
                                    <div>
                                        {expandedFlights?.includes(props?.flightToExpand) ? (<FaCircleArrowUp onClick={handleExpand} color="white" cursor="pointer" size={18} data-tippy-content="Hide Passengers" />) : (<FaCircleArrowDown onClick={handleExpand} color="white" cursor="pointer" size={18} data-tippy-content="Show Passengers" />)}
                                    </div>
                                )}
                            </div>

                        </div>

                    </div>



                </div>
            }

            {/* create additional passenger on flight modal */}
            {showAddPassenger == props.flight &&
                <ActionsModal
                    show={showAddPassenger == props.flight}
                    handleClose={closeModal}
                    title={"Add PRM Passenger to " + displayFlightNumber}
                    subtitle={"Please fill in the details of the additional passenger you want to add to flight " + displayFlightNumber + " and click the 'Add Passenger' button."}
                    isTimeline={true}
                >
                    <AdditionalPassengerForm type={type} addBooking={addBooking} flight={props.flight} handleClose={closeModal} />
                </ActionsModal>}
        </>

    );
};

export default FlightInformation;
